import messages from '@intlify/unplugin-vue-i18n/messages';
import { Quasar } from 'quasar';
import langFr from 'quasar/lang/fr';
import langEn from 'quasar/lang/en-US';
import { Ref } from 'vue';
import { createI18n } from 'vue-i18n';

import { constant } from '@/constant';
import { LanguageTranslation, Locales } from '@/store/language.interface';

export const i18n = createI18n({
  fallbackLocale: constant.DefaultLocale,
  globalInjection: true,
  legacy: false,
  locale: constant.DefaultLocale,
  messages,
});

export function currentLocale(): Locales {
  return i18n.global.locale.value as Locales;
}

export function getSupportedLocales(): Locales[] {
  return Object.keys(new LanguageTranslation()) as Locales[];
}

export function setLocale(locale: Locales): void {
  const language = (() => {
    switch (locale) {
      case 'en':
        return langEn;
      case 'fr':
      default:
        return langFr;
    }
  })();
  Quasar.lang.set(language);
  i18n.global.locale.value = locale;
  document.documentElement.lang = locale;
}

export function useCurrentLocale(): Ref<Locales> {
  return i18n.global.locale as Ref<Locales>;
}
